import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const TransactionStatesSerializability = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Query: Transaction States - Serial and Serializable Schedules"
    videos={[
      "https://www.youtube.com/embed/s8QlJoL1G6w",
      "https://www.youtube.com/embed/ET8VgPIEdHQ"
    ]}
    takeaways={[]}
    questions={[
      "1) Consider the following 3 schedules for 3 concurrent transactions T1, T2, T3\nS1 = (r2(c), r2(b), w2(b), r3(b), r3(d), r3 (c), r1(a), w1(a), w3(b), w3(c), r2(a), r2(d), w2(d), r1(b), w1(b), w2(a))\nS2 = (r3(b), r3(c), r3(d), r1(a), w1(a), w3(b), w3(c), r2(c), r1(b), w1(b), r2(b), w2(b), r2(a), w2 (a), r2(d), w2(d))\nS3 = (r1(a), w1(a), r2(c), r2(b), w2(b), r2(d), r2(a), w2(a), w2(d), r1(b), w2 (b), r3(b), r3(c), w3(b), w3(c), r3(d))\nFor each of the three interleaved schedules, determine if the schedule is serializable. If so give an equivalent serial schedule"
    ]}
    exampleVideos={[]}
  />
);
}

export default TransactionStatesSerializability;
